"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const bind_decorator_1 = require("bind-decorator");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const ProgressStepper_1 = __importDefault(require("../../../common/js/atoms/ProgressStepper"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const noop_1 = require("../../../common/js/helper/noop");
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const Paths = __importStar(require("../../constants/Paths"));
const DataLayerLabels_1 = __importDefault(require("../../enums/DataLayerLabels"));
const dataLayer_1 = require("../../helper/dataLayer");
const history_1 = require("../../helper/history");
const ShopwareCart_1 = __importDefault(require("../../stores/ShopwareCart"));
const ShopwareContext_1 = __importDefault(require("../../stores/ShopwareContext"));
const CHECKOUT_STEP_ORDER = [
    Paths.PATH_SHOP_CHECKOUT_SHIPPING,
    Paths.PATH_SHOP_CHECKOUT_PAYMENT,
    Paths.PATH_SHOP_CHECKOUT_SUMMARY,
    Paths.PATH_SHOP_CHECKOUT_PAY,
    Paths.PATH_SHOP_CHECKOUT_PAY_ERROR,
    Paths.PATH_SHOP_CHECKOUT_CONFIRMATION,
];
const NO_REDIRECT_PATHS = [
    Paths.PATH_SHOP_CHECKOUT_CONFIRMATION,
    Paths.PATH_SHOP_CHECKOUT_PAY,
    Paths.PATH_SHOP_CHECKOUT_PAY_ERROR,
];
class ShopCheckoutPage extends react_1.default.Component {
    checkoutStepMapping = {
        [Paths.PATH_SHOP_CHECKOUT_SHIPPING]: { label: (0, translation_1.t)('shop_checkout_page.stepper.shipping') },
        [Paths.PATH_SHOP_CHECKOUT_PAYMENT]: { label: (0, translation_1.t)('shop_checkout_page.stepper.payment') },
        [Paths.PATH_SHOP_CHECKOUT_SUMMARY]: { label: (0, translation_1.t)('shop_checkout_page.stepper.summary') },
        [Paths.PATH_SHOP_CHECKOUT_CONFIRMATION]: { label: (0, translation_1.t)('shop_checkout_page.stepper.confirmation') },
    };
    clearCartEmptyReaction = noop_1.noop;
    checkoutReset = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            doesCurrentPathNotAllowRedirects: mobx_1.computed,
            currentStepIndex: mobx_1.computed,
            isAllowedToChangeSteps: mobx_1.computed,
        });
    }
    get doesCurrentPathNotAllowRedirects() {
        return NO_REDIRECT_PATHS.findIndex((path) => this.isMatchingLocation(path)) >= 0;
    }
    get currentStepIndex() {
        switch (true) {
            case this.isMatchingLocation(Paths.PATH_SHOP_CHECKOUT_SHIPPING):
                return CHECKOUT_STEP_ORDER.indexOf(Paths.PATH_SHOP_CHECKOUT_SHIPPING);
            case this.isMatchingLocation(Paths.PATH_SHOP_CHECKOUT_PAYMENT):
                return CHECKOUT_STEP_ORDER.indexOf(Paths.PATH_SHOP_CHECKOUT_PAYMENT);
            case this.isMatchingLocation(Paths.PATH_SHOP_CHECKOUT_SUMMARY):
            case this.isMatchingLocation(Paths.PATH_SHOP_CHECKOUT_PAY):
            case this.isMatchingLocation(Paths.PATH_SHOP_CHECKOUT_PAY_ERROR):
                return CHECKOUT_STEP_ORDER.indexOf(Paths.PATH_SHOP_CHECKOUT_SUMMARY);
            case this.isMatchingLocation(Paths.PATH_SHOP_CHECKOUT_CONFIRMATION):
                return CHECKOUT_STEP_ORDER.indexOf(Paths.PATH_SHOP_CHECKOUT_CONFIRMATION);
            default:
                return -1;
        }
    }
    get isAllowedToChangeSteps() {
        return !ShopwareCart_1.default.isLoading && !ShopwareContext_1.default.isLoading && !this.doesCurrentPathNotAllowRedirects;
    }
    get steps() {
        return CHECKOUT_STEP_ORDER.map((key) => this.checkoutStepMapping[key]).filter((value) => !!value);
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('shop_subpage_title', { title: (0, translation_1.t)('shop_checkout_page.page_title') });
        (0, dataLayer_1.pushToDataLayerNavigation)({
            [DataLayerLabels_1.default.dlvNavigationLevelOne]: (0, translation_1.t)('navigation.shop.title'),
            [DataLayerLabels_1.default.dlvNavigationLevelTwo]: (0, translation_1.t)('shop_checkout_page.page_title'),
        });
        this.clearCartEmptyReaction = (0, mobx_1.reaction)(() => {
            return [
                ShopwareCart_1.default.isLoading || !ShopwareCart_1.default.cart ? null : ShopwareCart_1.default.productsCount,
                this.doesCurrentPathNotAllowRedirects,
            ];
        }, ([cartCount, doesCurrentPathNotAllowRedirects]) => {
            if (cartCount === null) {
                return;
            }
            if (doesCurrentPathNotAllowRedirects) {
                return;
            }
            if (cartCount === 0) {
                (0, history_1.replaceHistory)(this.props.history, Paths.PATH_SHOP_CART);
            }
            this.clearCartEmptyReaction();
        }, {
            fireImmediately: true,
        });
        if (this.doesCurrentPathNotAllowRedirects) {
            return;
        }
        if (this.currentStepIndex > 0) {
            (0, history_1.replaceHistory)(this.props.history, Paths.PATH_SHOP_CHECKOUT);
        }
    }
    componentWillUnmount() {
        this.clearCartEmptyReaction();
    }
    render() {
        const { route } = this.props;
        return (react_1.default.createElement("section", { className: "znd-shop-checkout-page" },
            react_1.default.createElement("div", { className: "znd-shop-checkout-page__stepper" },
                react_1.default.createElement(ProgressStepper_1.default, { active: this.currentStepIndex, steps: this.steps, onStepChange: this.isAllowedToChangeSteps ? this.onStepChange : undefined })),
            (0, react_router_config_1.renderRoutes)(route?.routes, { checkoutReset: this.checkoutReset })));
    }
    isMatchingLocation(path) {
        const regex = new RegExp(path.replace(/\/:[^/]*/g, '/.+'));
        return (this.props.location.pathname.match(regex)?.length ?? 0) > 0;
    }
    onStepChange(index) {
        if (!this.isAllowedToChangeSteps) {
            return;
        }
        const path = CHECKOUT_STEP_ORDER[index];
        if (!path || index > this.currentStepIndex || this.currentStepIndex === CHECKOUT_STEP_ORDER.length - 1) {
            return;
        }
        (0, history_1.pushHistory)(this.props.history, path);
    }
}
__decorate([
    bind_decorator_1.bind
], ShopCheckoutPage.prototype, "isMatchingLocation", null);
__decorate([
    bind_decorator_1.bind
], ShopCheckoutPage.prototype, "onStepChange", null);
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.ORDER_CREATE })((0, mobx_react_1.observer)(ShopCheckoutPage)));
